import styled from 'styled-components'

interface LabelProps {
  fontSize?: string
  color?: string
}

export const Label = styled.label<LabelProps>`
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : props.theme.font.textcaption};
  color: ${(props) =>
    props.color ? props.color : props.theme.color.neutral.gray};
`
